<div class="dialog">
  <div class="dialog-title">{{ title }}</div>
  <div class="dialog-description" [innerHTML]="desc"></div>
  <div class="dialog-divider"></div>
  <button class="dialog-button" mat-dialog-close (click)="onButtonClick()">
    {{ buttonText }}
  </button>
</div>
